export default __webpack_public_path__ + "static/media/OSMOS_CALCE_120X1206.5ac12739.jpg";